import {useEffect} from 'react';
import {useGetSubjectListQuery} from '../../api/candidateTest';
import {SelectFieldHookForm} from '../ui/SelectField';

const SubjectDropdown = ({
  queryEnabled = true,
  questionDetails = null,
  /* if this component is in the form,this will use to set value in form  */
  setValueInForm = null,
  /* check skill optinos array */
  optionsWithId,
  ...restProps
}) => {
  // call the query once we have questionDetails in case of component is in the edit form mode
  // else it will call directly on render
  const {data: subjectList, isFetching: isSkillLoading} =
    useGetSubjectListQuery(queryEnabled);

  const skillOptions = (subjectList?.data || []).map(({subject, _id}) => ({
    value: optionsWithId ? _id : subject,
    label: subject,
    id: _id,
  }));

  useEffect(() => {
    if (subjectList?.data && questionDetails && setValueInForm) {
      const ans = skillOptions.find(
        ({label}) => label === questionDetails.subject,
      );
      setValueInForm(ans);
    }
  }, [skillOptions, questionDetails, setValueInForm]);

  return (
    <SelectFieldHookForm
      options={skillOptions}
      isLoading={isSkillLoading}
      {...restProps}
    />
  );
};

export default SubjectDropdown;
